(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').config(Config);

  function Config($stateProvider) {
    $stateProvider
      .state('visualizacao.feitosMes', {
          url: "/feitosMes/:paiDK/:relMensalDk",
          templateUrl: "module/validacao/visualizacao/feitosMes/feitosMes.tab.html",
          controller: 'AbaFeitosMes',
          controllerAs: 'vm'
      })
    ;
  }

})();
